import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (
	item: OverallAmountCellContent.Props["item"],
) => {
	if (!isNumber(item?.ordersCounters?.overall?.amount)) return "";
	return formatNumber(item?.ordersCounters?.overall?.amount);
};

const OverallAmountCellContent: React.FC<OverallAmountCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace OverallAmountCellContent {
	interface Props {
		item: ExecutorReport.Model;
	}
}

export default OverallAmountCellContent;
